import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import { createFetchReducer } from '@trdk/style/Redux';

const rootReducer = combineReducers({
  profile: createFetchReducer('PROFILE', undefined, undefined),
  auth: createFetchReducer('AUTH', undefined, {}),
});

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
